import React from "react";
import { CardTheme } from "../types";

interface Draw2SymbolProps {
  theme: CardTheme;
}

export const Draw2Symbol: React.FC<Draw2SymbolProps> = React.memo(({ theme }) => {
  const { width, height } = theme.card;
  const centerX = width / 2;
  const centerY = height / 2;
  const fontSize = width * 0.25;
  const cornerFontSize = width * 0.12;

  return (
    <>
      {/* Large centered +2 */}
      <text
        x={centerX}
        y={centerY}
        fontSize={fontSize}
        fontWeight="bold"
        fill={theme.symbol.color}
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="Arial, sans-serif"
      >
        +2
      </text>

      {/* Top-left corner +2 */}
      <text
        x={width * 0.15}
        y={height * 0.2}
        fontSize={cornerFontSize}
        fontWeight="bold"
        fill={theme.symbol.color}
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="Arial, sans-serif"
      >
        +2
      </text>

      {/* Bottom-right corner +2 (rotated) */}
      <text
        x={width * 0.85}
        y={height * 0.8}
        fontSize={cornerFontSize}
        fontWeight="bold"
        fill={theme.symbol.color}
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="Arial, sans-serif"
        transform={`rotate(180 ${width * 0.85} ${height * 0.8})`}
      >
        +2
      </text>
    </>
  );
});

Draw2Symbol.displayName = "Draw2Symbol";
